// extracted by mini-css-extract-plugin
export default {"link":"Link_link__iQpNC","contents":"Link_contents__x32kV","underline":"Link_underline__RzFuJ"};